import { Sidebar, Content } from './HeaderSidebar.styled'

export type HeaderSidebarProps = {
  fill?: boolean
  sidebarWidth?: string
  sidebarMaxWidth?: string
}

const HeaderSidebar: React.FC<HeaderSidebarProps> = ({
  children,
  fill,
  sidebarWidth,
  sidebarMaxWidth,
}) => {
  return (
    <Sidebar
      isFill={fill}
      sidebarWidth={sidebarWidth}
      sidebarMaxWidth={sidebarMaxWidth}
      data-test='HeaderSidebar'
    >
      <Content>{children}</Content>
    </Sidebar>
  )
}

export default HeaderSidebar
